import {tradingViewChart, TradingViewChart} from "./chart/TradingViewComponent";

const ModuleName = "tfApp.components.tradingView.components";

export default angular.module(ModuleName, [])
    .component(TradingViewChart, tradingViewChart())
    .name;
